import React, { FC, memo } from 'react';
import { isUndefined, omitBy } from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import { Avatar } from '@src/components/Avatar';
import { getNameInitials } from '@src/util/getNameInitials';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { trackEvent } from '@src/metrics';
import { CandidateProps } from './props';
import './styles.scss';

export const Candidate: FC<CandidateProps> = memo(
  ({
    chatId,
    openingId,
    userName,
    userAvatarColor,
    lastMessage,
    applicationId,
    lastMessageCreatedAt,
    topic,
    hasUnread,
    selectChat,
    className,
  }) => {
    const lastMessageDate = moment(lastMessageCreatedAt);
    const isSentToday = moment(lastMessageDate).startOf('day').isSame(new Date(), 'day');

    return (
      <div
        className={classnames('inbox-candidate', !!hasUnread && 'inbox-candidate--unread', className)}
        onClick={() => {
          selectChat(chatId);

          trackEvent({
            context: MetricContext.CHAT,
            interaction: MetricAction.OPEN_CANDIDATE_CHAT_VIEW,
            payload: omitBy(
              {
                'Application Id': applicationId,
                'Event Source': MetricEventSource.CHATS_LIST_ITEM,
                'Opening Id': openingId,
                'Previous Context': MetricContext.CHATS,
                'Thread Id': chatId,
              },
              isUndefined,
            ),
          });
        }}
      >
        <Avatar
          avatarColor={userAvatarColor}
          className="inbox-candidate__avatar"
          initials={getNameInitials(userName)}
          size="x-large"
        />

        <div className="inbox-candidate__content">
          <div className="inbox-candidate__content-section">
            <span className={classnames('inbox-candidate__name', !!hasUnread && 'inbox-candidate__name--unread')}>
              {userName}
            </span>

            <span className="inbox-candidate__time">
              <span
                className={classnames(
                  'inbox-candidate__active-dot',
                  !!hasUnread && 'inbox-candidate__active-dot--show',
                )}
              />

              <span
                className={classnames(
                  'inbox-candidate__timestamp',
                  !!hasUnread && 'inbox-candidate__timestamp--unread',
                )}
              >
                {lastMessageDate.format(isSentToday ? 'HH:mm' : 'DD MMM')}
              </span>
            </span>
          </div>

          <div className="inbox-candidate__sub-title">{topic}</div>

          <div className={classnames('inbox-candidate__msg', !!hasUnread && 'inbox-candidate__msg--unread')}>
            {lastMessage}
          </div>
        </div>
      </div>
    );
  },
);
